module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgment"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', [_vm._v("A big thank you to all of those that encouraged me in my creative writing – you know who you are. Especially my husband Pat, for being a sounding board and reading all my chapters with enthusiasm and becoming my book reviewer – even though he much prefers vintage car magazines! To the other four men in my life, my sons, thanks for the help and interest shown. Darragh – my all-things technical man; Seán – the drummer who managed to keep the music down while I was writing. Joseph who helped with the proofreading and showed great patience. Patrick who is not really into books but might make an exception for this one.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ee3483c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0